const CustomLabel = ({ htmlFor, children }) => {
  const htmlForString = htmlFor?.toString();
  return (
    <label
      style={{
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: 'normal',
        color: '#414042',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
      }}
      htmlFor={htmlForString}
    >
      {children}
    </label>
  );
};

export default CustomLabel;
